<template lang='pug'>
.request-slide-out(:class='{ "has-request" : request !== null }')
	asset-slide-out(
		:state='state'
		:asset='request'
		:asset-key='assetKey'
		:asset-name='assetName'
		@close='$emit( "close" )'
		@delete='$emit( "delete" )'
		@edit='$emit( "edit" )'
		:class='dataState'
	)

		.title-container(
			slot='title'
		)
			h1.title Engineering Action Request Reference

		page.facilities-page.side-sheet-content(
			slot='side-sheet-content'
			:tabs='tabs'
		)

			.body-wrapper(slot='main-body')
				request(
					v-if='dataState === "loaded"'
					:request='request'
				)

				.loading-indicator.spacey(v-else-if='dataState === "loading"') Loading
					span .
					span .
					span .

				.failed.spacey(v-else-if='dataState === "failed"') Failed to load Engineering Action Request

			.body(slot='tab-comments' v-if='request')
				comments(
					:user='user'
					:section-id='`requests-${request.actionRequestsKey}`'
					@replied-to-comment='email'
				)

			.body.documents.separate-gradient.down(slot='tab-documents' v-if='request')
				document-list(
					:documents='request.folder'
					:a-files='request.file'
					:assetKey='request.actionRequestsKey'
					@close='$emit( "close" )'
				)
</template>

<script>
import Request from '@/components/slide-outs/requests/Request';
import SideSheet from '@/components/SideSheet';
import AssetSlideOut from '@/components/slide-outs/AssetSlideOut';
import Page from '@/components/Page';
import Comments from '@/components/comments';
import DocumentList from '@/components/DocumentList';

import { objectOrNull } from '@/lib/vue-validators';

import { SendEmail } from '@/lib/API';

export default {
	name : 'request-slide-out',

	props : {
		state : {
			type     : String,
			required : true,
		},

		dataState : {
			type     : String,
			required : true,
		},

		request : {
			required  : true,
			validator : objectOrNull,
		},

		assetKey : {
			required : true,
		},

		assetName : {
			type : String,
		}
	},

	data : () => ( {

		tabs : {
			'comments'  : 'Comments',
			'documents' : 'Documents',
		},

	} ),

	computed : {
		user() {
			return this.$store.state.postgresUser;
		}
	},

	methods : {

		email( recipientKey, link ) {
			const { request } = this;

			const sectionDescription = `Request #${request.number}`;

			const emailData = {
				sectionDescription,
				link
			};

			SendEmail( this.user.usersKey, [recipientKey], 'reply', emailData );
		},

	},

	components : {
		Request,
		SideSheet,
		AssetSlideOut,
		Page,
		Comments,
		DocumentList,
	}
};
</script>

<style lang='scss'>
.request-slide-out {

	&:not(.has-request) {

		.toggle,
		.main {
			opacity: 0;
		}
	}

	.body-wrapper {
		width: 100%;

		.loading-indicator {
			text-align: center;
		}
	}

	.body {

		> p.spacey {
			text-align: center;
		}

		.document-list {
			padding: 15px;
		}
	}

	.asset-slide-out.loaded {

		.side-sheet.opened {

			.swiper-slide > .page > .header {
				position: absolute;
				z-index: 10;
				width: 100%;

				// .buttons-container {

				// 	.icon-pencil {
				// 		display: none;
				// 	}
				// }
			}
		}
	}
}
</style>
